module.exports = "/_next/static/images/279e0afcb97c6354e9e8b7105ad4438e-soriana-icon.svg";